foodly.define(['jquery', 'jquery.currencies', 'shopInfo', "dropdowns"], function(jQuery, Currency, shopInfo, Dropdown){
//debugger;
  Currency.format = 'money_format';
  var shopCurrency = shopInfo.currency;

  /* Sometimes merchants change their shop currency, let's tell our JavaScript file */
  Currency.moneyFormats[shopCurrency].money_with_currency_format = shopInfo.moneyWithCurrencyFormat;
  Currency.moneyFormats[shopCurrency].money_format = shopInfo.moneyFormat;

  /* Default currency */
  var defaultCurrency = '';
  defaultCurrency = defaultCurrency || shopCurrency; /*In case settings.default_currency is empty let's put there shop.currency*/

  /* Cookie currency */
  var cookieCurrency = Currency.cookie.read();
  /* Fix for customer account pages */
  jQuery('span.money span.money').each(function() {
    jQuery(this).parents('span.money').removeClass('money');
  });
  /* Saving the current price */
  jQuery('span.money').each(function() {
    jQuery(this).attr('data-currency-' + defaultCurrency, jQuery(this).html());
  });
  // If there's no cookie.
  if (cookieCurrency == null) {
    if (shopCurrency !== defaultCurrency) {
      Currency.convertAll(shopCurrency, defaultCurrency);
    }
    else {
      Currency.currentCurrency = defaultCurrency;
    }
  }
  // If the cookie value does not correspond to any value in the currency dropdown.
  else if (jQuery('[name=currencies]').size() && jQuery('[name=currencies] option[value=' + cookieCurrency + ']').size() === 0) {
    Currency.currentCurrency = shopCurrency;
    Currency.cookie.write(shopCurrency);
  }
  else if (cookieCurrency === shopCurrency) {
    Currency.currentCurrency = shopCurrency;
  }
  else {
    Currency.convertAll(shopCurrency, cookieCurrency);
  }
  jQuery('[name=currencies]').val(Currency.currentCurrency).change(function() {
    var newCurrency = jQuery(this).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
    jQuery('.selected-currency').text(Currency.currentCurrency);
  });
  var original_selectCallback = window.selectCallback;
  var selectCallback = function(variant, selector) {
    original_selectCallback(variant, selector);
    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
    jQuery('.selected-currency').text(Currency.currentCurrency);
  };
  jQuery('body').on('ajaxCart.afterCartLoad', function(cart) {
    Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
    jQuery('.selected-currency').text(Currency.currentCurrency);
  });
  jQuery('.selected-currency').text(Currency.currentCurrency);

  jQuery('body').removeClass('currency-is-hide');

  if (document.querySelector('select.js-dropdown-currency')) {
    Dropdown.initCurrencyDropdown('.js-dropdown-currency');
  }
});
